module.exports = __webpack_public_path__ + "static/media/10-point-bench.66955d89.png";